import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { useAuth, signOut } from '../AuthContext';
import { useJobs, jobIsActive, canUseControls } from '../data/firestore';

const APP_NAME = process.env.REACT_APP_APP_NAME || 'starter';

export default function Navbar() {
  const { user } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const jobs = useJobs(100, !!user);
  const activeJobs = (jobs || []).filter(jobIsActive).length;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Collapse the mobile menu whenever we navigate to a new route.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const close = () => setOpen(false);

  return (
    <nav className={`cs-nav ${scrolled || open ? 'scrolled' : ''} ${open ? 'open' : ''}`}>
      <Link to="/" className="cs-brand" onClick={close}>
        <img src="/brand/amalfi-logo.png" alt="" className="cs-brand-logo" />
        <span className="cs-brand-name">
          <span className="cs-brand-word1">{APP_NAME.split(' ')[0]}</span>
          <span className="cs-brand-word2">{APP_NAME.split(' ').slice(1).join(' ')}</span>
        </span>
      </Link>
      <button
        type="button"
        className="cs-nav-burger"
        onClick={() => setOpen((o) => !o)}
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
      >
        {open ? '✕' : '☰'}
      </button>
      <div className="cs-nav-links">
        <NavLink to="/" end onClick={close}>
          The House
        </NavLink>
        <NavLink to="/rooms" onClick={close}>
          Rooms
        </NavLink>
        <NavLink to="/designs" onClick={close}>
          Designs
        </NavLink>
        {canUseControls(user) && (
          <NavLink to="/controls" onClick={close}>
            Controls
          </NavLink>
        )}
        {user && (
          <NavLink to="/jobs" className="cs-nav-jobs" onClick={close}>
            Processes
            {activeJobs > 0 && <span className="cs-nav-jobs-badge">{activeJobs}</span>}
          </NavLink>
        )}
        {user && (
          <NavLink to="/docs" onClick={close}>
            Docs
          </NavLink>
        )}
      </div>
      <div className="cs-nav-spacer" />
      {user ? (
        <div className="cs-nav-user">
          <span className="cs-nav-email">{user.email}</span>
          <button className="cs-btn cs-btn-outline cs-btn-sm" onClick={() => signOut()}>
            Sign out
          </button>
        </div>
      ) : (
        <div className="cs-nav-user">
          <Link to="/login" className="cs-btn cs-btn-outline cs-btn-sm" onClick={close}>
            Sign in
          </Link>
        </div>
      )}
    </nav>
  );
}
